import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router";
import { useAppSelector } from "../app/hooks";
import { UserRole } from "../app/userSlice";

export default function RequireCourse(props: any) {
	const course = useAppSelector((state) => state.user.course);
	const role = useAppSelector((state) => state.user.role);
	const navigate = useNavigate();

	const courseRequired = role === UserRole.Writer || role === UserRole.Proctor;

	useEffect(() => {
		if (!course && courseRequired) {
			navigate("/courses");
		}
	});

	if (!course && !courseRequired) navigate("/adminHome");

	return <Outlet />;
}
